<div class="p-3" style="min-width: 320px;">
    <ahr-test-clock (done)="dialogRef.close()"></ahr-test-clock>
    <div class="text-right mt-2">
        <button class="btn btn-outline-secondary" (click)="dialogRef.close()">Cancel</button>
    </div>
</div>
